import AvatarToggleRow from "Components/Common/AvatarToggleRow";
import BreadCrumb from "Components/Common/BreadCrumb";
import FullScreenLoader from "Components/Common/FullScreenLoader";
import { useAppDispatch, useAppSelector } from "Components/Hooks/hooks";
import { useFormik } from "formik";
import { useState } from "react";
import { Card, CardBody, Col, Container } from "reactstrap";
import { manageNotificationSettings } from "slices/thunks";
import { ErrorToast } from "utils/toast";

interface NotificationsPreferenceValues {
  pushNotifications: boolean;
  emailUpdates: boolean;
}

const NotificationsPreference = () => {
  const dispatch = useAppDispatch();
  const configData = useAppSelector((state) => state.config.configData);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const validation = useFormik<NotificationsPreferenceValues>({
    enableReinitialize: true,
    initialValues: {
      pushNotifications:
        configData?.notification_settings?.push_notification_enabled ?? false,
      emailUpdates:
        configData?.notification_settings?.email_notification_enabled ?? false,
    },
    onSubmit: (values) => {
      console.log(values);
    },
  });

  const boolToValue = (flag: boolean) => (flag ? 1 : 0);

  const handleToggle = async (type: "push" | "email") => {
    console.log(validation.values);

    const permission = Notification.permission;

    if (permission === "denied" || permission === "default") {
      await Notification.requestPermission();
    }
    if (permission !== "granted") {
      ErrorToast("Please allow notification permission from browser settings.");
      return;
    }
    // return;
    try {
      setIsLoading(true);
      if (type === "push") {
        await dispatch(
          manageNotificationSettings({
            push_notification_enabled: boolToValue(
              !validation.values["pushNotifications"]
            ),
            email_notification_enabled: boolToValue(
              validation.values["emailUpdates"]
            ),
          })
        )?.unwrap();
      } else {
        await dispatch(
          manageNotificationSettings({
            push_notification_enabled: boolToValue(
              validation.values["pushNotifications"]
            ),
            email_notification_enabled: boolToValue(
              !validation.values["emailUpdates"]
            ),
          })
        )?.unwrap();
      }
    } catch (error) {
      console.log("Error updating notification settings:", error);
    } finally {
      setIsLoading(false);
    }
  };

  document.title = "Notifications Preference | EaziQuote";

  return (
    <>
      <FullScreenLoader isLoading={isLoading} message="Updating..." />
      <div className="page-content">
        <Container fluid>
          <BreadCrumb
            title="Notifications preference"
            pageTitle="Settings"
            url="/settings"
          />

          <Card className="bg-white br-10">
            <CardBody className="p-4 mt-0">
              <AvatarToggleRow
                label="Push Notifications"
                icon="NotificationBordered"
                name="pushNotifications"
                value={validation.values.pushNotifications}
                onToggle={() => handleToggle("push")}
              />

              <Col md="12">
                <div className="divider  my-3" />
              </Col>

              <AvatarToggleRow
                label="Email Updates"
                icon="EmailBordered"
                name="emailUpdates"
                value={validation.values.emailUpdates}
                onToggle={() => handleToggle("email")}
              />
            </CardBody>
          </Card>
        </Container>
      </div>
    </>
  );
};

export default NotificationsPreference;
